import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useTheme } from '../../../../../theme';

export const WeeklyHeader: React.FunctionComponent = () => {
	const { t } = useTranslation('Datepicker');
	const theme = useTheme('Datepicker').WeeklyHeaderStyles;

	return (
		<div className={theme.week}>
			{[...Array(7)].map((_, index) => (
				<div key={index} className={cn(theme.day, theme.dayOfWeekName)}>
					<span>{t(`week_short_${index}`)}</span>
				</div>
			))}
		</div>
	);
};
